<script lang="ts">
    import { onMount } from 'svelte';
    import TableList from '../framework/components/TableList.svelte';
    import { AppPageHeader } from '../framework/components/app';
    import { api } from '../framework/js/api.js';

    interface Field {
        key: string;
        label: string;
        type: string;
        editable: boolean;
        sortable: boolean;
        model_key?: string;
        value?: string;
    }

    interface Details {
        titleList: string;
        titleEdit: string;
        create: boolean;
        delete: boolean;
        edit: boolean;
        hasMediaFile: boolean;
        mediaFileType: string;
        sortby: string;
    }

    interface TableData {
        details: Details;
        fields: Field[];
    }

    interface BriefType {
        uuid: string;
        name: string;
    }

    let briefTypes: BriefType[] = [];
    let selectedBriefUuid = '';

    onMount(async () => {
        await loadBriefTypes();
    });

    async function loadBriefTypes() {
        try {
            // Request newest first so we can default to the first (newest) brief
            const params = { column: 'created_at', order: 'desc', per_page: 500 };
            const response = await api.crudIndex('xplorit-type-brief', params as any) as { success?: boolean; data?: BriefType[] | { data?: BriefType[] } };
            if (response && response.success && response.data) {
                briefTypes = Array.isArray(response.data)
                    ? response.data
                    : (response.data.data || []);
                // Default to the newest brief (first in list); no "All briefs" option
                selectedBriefUuid = briefTypes.length > 0 ? briefTypes[0].uuid : '';
            }
        } catch (err) {
            console.error('Error loading brief types:', err);
        }
    }

    const tableData: TableData = {
        details: {
            titleList: 'BtoB Questions',
            titleEdit: 'Question',
            create: true,
            delete: true,
            edit: true,
            hasMediaFile: false,
            mediaFileType: 'image/*',
            sortby: 'sort_order',
        },
        fields: [
            {
                key: 'sort_order',
                label: 'Order',
                type: 'text',
                editable: true,
                sortable: true,
            },
            ...(selectedBriefUuid ? [] : [{
                key: 'xplorit_type_brief.name',
                label: 'Brief',
                type: 'text',
                editable: false,
                sortable: false,
            } as Field]),
            {
                key: 'question_prefix',
                label: 'Prefix',
                type: 'text',
                editable: true,
                sortable: true,
            },
            {
                key: 'question_content',
                label: 'Question',
                type: 'textarea',
                editable: true,
                sortable: true,
            },
            {
                key: 'question_prompt',
                label: 'Prompt',
                type: 'textarea',
                editable: true,
                sortable: true,
            },
        ],
    };

    $: extraParms = selectedBriefUuid
        ? '&xplorit_type_brief_uuid=' + encodeURIComponent(selectedBriefUuid)
        : '';

    $: tableDataForList = tableData as any;
</script>

<div class="page-shell admin-list brief-question-list">
    <AppPageHeader
        title="BtoB Questions"
        subtitle="Manage Built-to-Brief question sets by brief type"
        showAction={false}
    />

    <div class="filters-bar filters-bar--labeled">
        <div class="filter-group">
            <label for="brief-type-filter" class="filter-label">Brief type</label>
            <select
                id="brief-type-filter"
                bind:value={selectedBriefUuid}
                class="filter-select"
                aria-label="Filter questions by brief type"
            >
            {#each briefTypes as bt (bt.uuid)}
                <option value={bt.uuid}>{bt.name}</option>
            {/each}
            </select>
        </div>
    </div>

    {#key selectedBriefUuid}
        <TableList
            modelName="xplorit-type-brief-question"
            tableData={tableDataForList}
            {extraParms}
        />
    {/key}
</div>

<style>
    .brief-question-list .filter-select {
        min-width: 200px;
        max-width: 360px;
    }
</style>